module.exports = __webpack_public_path__ + "static/media/team.31c7575f.webp";